import type {
  IAuthChangePasswordParams,
  IAuthParams,
  IAuthResetPasswordParams,
  ISignupParams,
} from '@/types/params/auth';
import { loadLocalUser } from '@/utils/local_storage';
import { backendAPI } from '@/services/base_api';

export const login = (user: IAuthParams): Promise<any> => {
  return new Promise((resolve, reject) => {
    // { withCredentials: true }  is for cookies
    return backendAPI('POST', '/api/login', user, {}, null, true)
      .then((resp) => {
        resolve(resp.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const googleLogin = (formData: { access_token: string }): Promise<any> => {
  return new Promise((resolve, reject) => {
    // { withCredentials: true }  is for cookies
    return backendAPI('POST', '/api/google/login', formData, {}, null, true)
      .then((resp) => {
        resolve(resp.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const auth = (): Promise<any> => {
  return new Promise((resolve, reject) => {
    const userData = loadLocalUser();
    if (!userData || !userData.accessToken) reject({});

    // POST method - no cache-busting needed (POST is never cached)
    return backendAPI('POST', '/api/refresh')
      .then((resp) => {
        const data = resp.status == 200 ? resp.data : {};
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const userProfile = (): Promise<any> => {
  const params = {};
  return backendAPI('GET', `/api/profile`, params, {}, null);
};

export const forgotPassword = (formData: { email: string; language?: string }): Promise<any> => {
  return backendAPI('POST', '/api/auth/forgot-password', formData, {});
};

export const resetPassword = (formData: IAuthResetPasswordParams): Promise<any> => {
  return backendAPI('POST', '/api/auth/reset-password', formData, {});
};

export const checkEmail = (formData: { email: string }): Promise<any> => {
  return backendAPI('POST', `/api/check-email`, formData);
};

export const sendVerificationCode = (formData: { email: string; language?: string }): Promise<any> => {
  return backendAPI('POST', `/api/auth/send-verification-code`, formData);
};

export const resendCode = (formData: { email: string }): Promise<any> => {
  return backendAPI('POST', `/api/auth/resend-code`, formData);
};

export const verifyCode = (formData: { email: string; otp: string }): Promise<any> => {
  return backendAPI('POST', `/api/auth/verify-code`, formData);
};

export const signup = (formData: ISignupParams): Promise<any> => {
  return new Promise((resolve, reject) => {
    return backendAPI('POST', '/api/auth/signup', formData, {})
      .then((resp) => {
        resolve(resp.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const googleSignup = (formData: { access_token: string }): Promise<any> => {
  return new Promise((resolve, reject) => {
    return backendAPI('POST', '/api/google/signup', formData, {})
      .then((resp) => {
        resolve(resp.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const changePassword = (formData: IAuthChangePasswordParams): Promise<any> => {
  return backendAPI('POST', '/api/auth/change-password', formData, {});
};
